import React from 'react';

export interface EmptyPredictionsTextProps
  extends React.HTMLProps<HTMLDivElement> {
  text: string;
}

const EmptyPredictionsText: React.FC<EmptyPredictionsTextProps> = ({
  text,
  ...props
}) => (
  <div
    className={`text-[1.4rem] font-semibold leading-[1.8rem] text-center text-[#000c42] mt-[2rem] ${props.className ?? ''}`}
    {...props}
  >
    {text}
  </div>
);

export default EmptyPredictionsText;
